import * as React from "react";

export const CalendarIcon = (props: any) => (
  <svg
    width={20}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.167 2.5H17.5a.833.833 0 0 1 .833.833v13.334a.833.833 0 0 1-.833.833h-15a.833.833 0 0 1-.833-.833V3.333A.833.833 0 0 1 2.5 2.5h3.333V.833H7.5V2.5h5V.833h1.667V2.5ZM12.5 4.167h-5v1.666H5.833V4.167h-2.5V7.5h13.334V4.167h-2.5v1.666H12.5V4.167Zm4.167 5H3.333v6.666h13.334V9.167Z"
      fill="#646363"
    />
  </svg>
);
